import { useMutation } from '@tanstack/react-query';
import { putModfyPassword } from '@entities/user/api/user';
/**
 * useModifyPasswordMutation
 * 비밀번호 변경 용도
 */
function useModifyPasswordMutation(options = {}) {
  return useMutation({
    mutationFn: putModfyPassword,
    onSuccess: (data) => {
      const code = data?.result_code;
      if (code !== 0) {
        const message = data?.error_msg || '비밀번호 틀림';
        let friendlyMsg = message;

        if ([100].includes(code)) {
          friendlyMsg = '비밀번호가 잘못되었습니다.';
        }
        if (options.onError) {
          options.onError({ friendlyMsg });
        }
        return;
      }
      if (options.onSuccess) options.onSuccess(data);
    },
    onError: options.onError || ((err) => console.error(err)),
  });
}
export { useModifyPasswordMutation };
